<template>
  <div class="page-col page-main remessa-cadastro" :class="{'bg-dark': isDark}">
    <!-- Header Padrao -->
    <HeaderPadrao 
      class="mb-3" 
      icon="fa fa-barcode" 
      :titulo="tituloTela"
    >
      <template #subtitulo>
        <i class="fa fa-info-circle mr-1 text-info"></i>
        {{ subtitulo || 'Gerenciamento de remessa bancária' }}
      </template>

      <template #acoes>
        <b-button variant="link" class="btn-glass btn-glass-success mr-2" @click="gerarRemessa" :disabled="!podeGerar" v-if="isNovo">
          <i class="fa fa-file-text-o mr-1"></i> GERAR REMESSA
        </b-button>

        <b-button variant="light" pill class="font-weight-bold shadow-sm" @click="voltar">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="px-3">
      <!-- Seção Dados Gerais -->
      <div class="card border-0 shadow-sm rounded-lg overflow-hidden mb-4" :class="isDark ? 'bg-dark border-secondary' : 'bg-white'">
        <div class="card-header bg-transparent border-0 p-4 pb-0">
          <div class="d-flex align-items-center">
            <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;">
              <i class="fa fa-info-circle"></i>
            </div>
            <h6 class="mb-0 font-weight-bold">Dados Gerais da Remessa</h6>
          </div>
        </div>
        <div class="card-body p-4">
          <b-row>
            <b-col md="6">
              <label class="modal-label-premium">Empresa</label>
              <b-form-select
                v-model="remessa.EMPRESA_ID"
                :options="empresas"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
              >
                <template #first>
                  <option :value="null">Selecione a empresa</option>
                </template>
              </b-form-select>
            </b-col>

            <b-col md="6">
              <label class="modal-label-premium">Conta Bancária</label>
              <b-form-select
                v-model="remessa.CONTA_ID"
                :options="contas"
                :disabled="!isNovo"
                class="rounded-pill shadow-xs"
                @change="onContaChange"
              >
                <template #first>
                  <option :value="null">Selecione a conta bancária</option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="4">
              <label class="modal-label-premium">Data Cadastro</label>
              <CecInputData
                v-model="remessa.DATA_CADASTRO"
                :disabled="!isNovo"
                input-class="rounded-pill shadow-xs"
              />
            </b-col>

            <b-col md="4">
              <label class="modal-label-premium">Número do Arquivo</label>
              <b-form-input
                v-model="remessa.NUMERO_ARQUIVO"
                disabled
                class="rounded-pill shadow-xs bg-light"
              />
            </b-col>

            <b-col md="4">
              <label class="modal-label-premium">Nome do Arquivo</label>
              <b-form-input
                v-model="remessa.NOME_ARQUIVO_REMESSA"
                disabled
                class="rounded-pill shadow-xs bg-light"
              />
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="12">
              <label class="modal-label-premium">Observação</label>
              <b-form-textarea
                v-model="remessa.OBSERVACAO"
                :disabled="!isNovo"
                rows="2"
                class="rounded-pill-20 shadow-xs px-4 py-3"
                placeholder="Observações internas da remessa..."
              />
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Seção Boletos -->
      <div class="card border-0 shadow-sm rounded-lg overflow-hidden mb-4" :class="isDark ? 'bg-dark border-secondary' : 'bg-white'">
        <div class="card-header bg-transparent border-0 p-4 pb-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;">
                <i class="fa fa-list"></i>
              </div>
              <h6 class="mb-0 font-weight-bold">Boletos da Remessa</h6>
            </div>
            <div v-if="isNovo && remessa.CONTA_ID">
              <b-button 
                size="sm" 
                variant="soft-primary" 
                pill
                @click="marcarTodos" 
                :disabled="boletos.length === 0"
                class="mr-2 px-3"
              >
                <i class="fa fa-check-square-o mr-1"></i> Marcar Todos
              </b-button>
              <b-button 
                size="sm" 
                variant="soft-secondary" 
                pill
                @click="desmarcarTodos" 
                :disabled="boletos.length === 0"
                class="px-3"
              >
                <i class="fa fa-square-o mr-1"></i> Desmarcar Todos
              </b-button>
            </div>
          </div>
        </div>

        <div class="card-body p-4">
          <b-alert v-if="!remessa.CONTA_ID" show variant="info" class="border-0 shadow-sm rounded-lg">
            <i class="fa fa-info-circle mr-2"></i> Selecione uma conta bancária para visualizar os boletos disponíveis.
          </b-alert>

          <div v-if="remessa.CONTA_ID">
            <b-row class="mb-4">
              <b-col md="4">
                <div class="p-3 rounded-lg bg-soft-success border-0 shadow-xs h-100 text-center">
                  <div class="modal-label-premium mb-1">Boletos Marcados</div>
                  <div class="h4 mb-0 font-weight-bold text-success">{{ quantidadeMarcados }}</div>
                </div>
              </b-col>
              <b-col md="4">
                <div class="p-3 rounded-lg bg-soft-info border-0 shadow-xs h-100 text-center">
                  <div class="modal-label-premium mb-1">Valor Total da Lista</div>
                  <div class="h4 mb-0 font-weight-bold text-info">{{ formatCurrency(valorTotalLista) }}</div>
                </div>
              </b-col>
              <b-col md="4">
                <div class="p-3 rounded-lg bg-soft-primary border-0 shadow-xs h-100 text-center">
                  <div class="modal-label-premium mb-1">Valor Total Marcado</div>
                  <div class="h4 mb-0 font-weight-bold text-primary">{{ formatCurrency(valorTotalMarcados) }}</div>
                </div>
              </b-col>
            </b-row>

            <div class="table-responsive rounded border shadow-sm overflow-hidden">
              <b-table
                :items="boletos"
                :fields="colunasBoletos"
                :busy="loadingBoletos"
                class="modern-premium-table mb-0"
                hover
                small
                show-empty
                empty-text="Nenhum boleto disponível para esta conta"
                :tbody-tr-class="rowClassBoleto"
              >
                <template #cell(selecionado)="data">
                  <b-form-checkbox
                    v-if="isNovo"
                    v-model="data.item.SELECIONADO"
                    @change="onBoletoSelectionChange"
                    class="custom-checkbox-premium"
                  />
                </template>

                <template #cell(TITULO_VENCIMENTO)="data">
                  <span class="text-muted">{{ formatDate(data.value) }}</span>
                </template>

                <template #cell(TITULO_DATADOCUMENTO)="data">
                  <span class="text-muted">{{ formatDate(data.value) }}</span>
                </template>

                <template #cell(VALOR_TITULO)="data">
                  <span class="font-weight-bold text-primary">{{ formatCurrency(data.value) }}</span>
                </template>

                <template #table-busy>
                  <div class="text-center text-primary my-4">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>Carregando boletos...</strong>
                  </div>
                </template>

                <template #custom-foot>
                  <b-tr class="bg-light font-weight-bold">
                    <b-td :colspan="isNovo ? 6 : 5" class="text-right">Total Marcado:</b-td>
                    <b-td class="text-right text-primary">{{ formatCurrency(valorTotalMarcados) }}</b-td>
                  </b-tr>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import CecInputData from '@/components/Cec/CecInputData.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'

export default {
  name: 'BoletoRemessaCadastro',
  components: { CecInputData, HeaderPadrao },
  props: {
    id: { type: [String, Number], default: null }
  },
  data() {
    return {
      remessa: {
        ID: null,
        DATA_CADASTRO: moment().format('YYYY-MM-DD'),
        CONTA_ID: null,
        BANCO_ID: null,
        CEDENTE_NOME: '',
        CEDENTE_CONTA: '',
        CEDENTE_CONTADIGITO: '',
        CEDENTE_AGENCIA: '',
        CEDENTE_AGENCIADIGITO: '',
        OBSERVACAO: '',
        NUMERO_ARQUIVO: '',
        NOME_ARQUIVO_REMESSA: '',
        EMPRESA_ID: null,
        STATUS: '1', // 1 = Cadastrada
        OP_LAYOUT_REMESSA_BOLETO: null,
        OP_TIPO_REMESSA_BOLETO: null
      },
      boletos: [],
      loadingBoletos: false,
      empresas: [],
      contas: [],
      colunasBoletos: []
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    
    isNovo() {
      return !this.remessa.ID || this.remessa.ID === 'novo'
    },
    
    tituloTela() {
      return this.isNovo ? 'Cadastro de Remessa de Boletos' : 'Consultando Remessa de Boletos'
    },
    
    podeGerar() {
      return this.isNovo && this.quantidadeMarcados > 0
    },
    
    statusDescricao() {
      const statusMap = {
        '0': 'Cancelada',
        '1': 'Cadastrada',
        '2': 'Remessa Enviada ao Banco',
        '3': 'Retorno Recebido'
      }
      const status = String(this.remessa.STATUS || '').trim()
      return statusMap[status] || ''
    },
    
    statusTextoCompleto() {
      const status = String(this.remessa.STATUS || '').trim()
      const descricao = this.statusDescricao
      return descricao ? `${status} - ${descricao}` : ''
    },
    
    statusBadgeClass() {
      const status = String(this.remessa.STATUS || '').trim()
      const classMap = {
        '0': 'badge badge-danger',
        '1': 'badge badge-info',
        '2': 'badge badge-success',
        '3': 'badge badge-primary'
      }
      return classMap[status] || 'badge badge-secondary'
    },
    
    subtitulo() {
      const parts = []
      if (this.remessa.ID && this.remessa.ID !== 'novo') {
        parts.push(`#${this.remessa.ID}`)
      }
      if (this.remessa.CEDENTE_NOME) {
        parts.push(this.remessa.CEDENTE_NOME)
      }
      return parts.length > 0 ? parts.join(' - ') : ''
    },
    
    quantidadeMarcados() {
      return this.boletos.filter(b => b.SELECIONADO).length
    },
    
    valorTotalLista() {
      return this.boletos.reduce((sum, b) => sum + (Number(b.VALOR_TITULO) || 0), 0)
    },
    
    valorTotalMarcados() {
      return this.boletos
        .filter(b => b.SELECIONADO)
        .reduce((sum, b) => sum + (Number(b.VALOR_TITULO) || 0), 0)
    }
  },
  created() {
    this.carregarEmpresas()
    this.carregarContas()
    
    const routeId = this.id || (this.$route && this.$route.params && this.$route.params.id)
    if (routeId && routeId !== 'novo') {
      this.carregarRemessa(routeId)
    }
    
    // Definir colunas dinamicamente
    this.atualizarColunas()
  },
  
  watch: {
    isNovo() {
      this.atualizarColunas()
    }
  },
  methods: {
    atualizarColunas() {
      const colunasBase = [
        { key: 'SACADO_NOMESACADO', label: 'Sacado', sortable: true, class: 'align-middle', thStyle: { width: this.isNovo ? '30%' : '32%' } },
        { key: 'TITULO_VENCIMENTO', label: 'Vencimento', sortable: true, class: 'align-middle text-center', thStyle: { width: '12%' } },
        { key: 'TITULO_DATADOCUMENTO', label: 'Dt. Documento', sortable: true, class: 'align-middle text-center', thStyle: { width: '12%' } },
        { key: 'TITULO_NOSSONUMERO', label: 'Nosso Número', sortable: true, class: 'align-middle', thStyle: { width: '15%' } },
        { key: 'TITULO_NUMERODOCUMENTO', label: 'Nº Documento', sortable: true, class: 'align-middle', thStyle: { width: '15%' } },
        { key: 'VALOR_TITULO', label: 'Valor', sortable: true, class: 'align-middle text-right', thStyle: { width: '12%' } }
      ]
      
      if (this.isNovo) {
        this.colunasBoletos = [
          { key: 'selecionado', label: '', class: 'text-center', thStyle: { width: '5%' } },
          ...colunasBase
        ]
      } else {
        this.colunasBoletos = colunasBase
      }
    },
    
    async carregarEmpresas() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getTodas')
        this.empresas = (data || []).map(emp => ({
          value: emp.CODIGO,
          text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}`
        }))
      } catch (err) {
        console.error('Erro ao carregar empresas:', err)
      }
    },
    
    async carregarContas() {
      try {
        const body = {
          login: window.localStorage.getItem('login'),
          origem: 'web'
        }
        
        const { data } = await this.$http.post('/api/protected/conta/listarPorLogin', body)
        this.contas = (data || []).map(conta => ({
          value: conta.CODIGO,
          text: conta.NOME_CONTA
        }))
      } catch (err) {
        console.error('Erro ao carregar contas:', err)
        this.$bvToast.toast('Erro ao carregar contas bancárias', { variant: 'danger', solid: true })
      }
    },
    
    async carregarRemessa(id) {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const { data } = await this.$http.get(`/api/protected/boleto/remessa/getById/${id}`)
        const registro = Array.isArray(data) ? data[0] : data
        
        if (!registro) {
          throw new Error('Remessa não encontrada')
        }
        
        Object.assign(this.remessa, {
          ID: registro.ID,
          DATA_CADASTRO: registro.DATA_CADASTRO ? moment(registro.DATA_CADASTRO).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
          CONTA_ID: registro.CONTA_ID,
          BANCO_ID: registro.BANCO_ID,
          CEDENTE_NOME: registro.CEDENTE_NOME || '',
          CEDENTE_CONTA: registro.CEDENTE_CONTA || '',
          CEDENTE_CONTADIGITO: registro.CEDENTE_CONTADIGITO || '',
          CEDENTE_AGENCIA: registro.CEDENTE_AGENCIA || '',
          CEDENTE_AGENCIADIGITO: registro.CEDENTE_AGENCIADIGITO || '',
          OBSERVACAO: registro.OBSERVACAO || '',
          NUMERO_ARQUIVO: registro.NUMERO_ARQUIVO || '',
          NOME_ARQUIVO_REMESSA: registro.NOME_ARQUIVO_REMESSA || '',
          EMPRESA_ID: registro.EMPRESA_ID,
          STATUS: registro.STATUS || '1',
          OP_LAYOUT_REMESSA_BOLETO: registro.OP_LAYOUT_REMESSA_BOLETO,
          OP_TIPO_REMESSA_BOLETO: registro.OP_TIPO_REMESSA_BOLETO
        })
        
        // Carregar boletos da remessa
        if (this.remessa.CONTA_ID) {
          await this.carregarBoletos()
        }
        
        // Setar o ID no store para manter destaque na listagem
        if (this.remessa.ID) {
          this.$store.commit('boletoRemessa/SET_REGISTRO_SELECIONADO_ID', this.remessa.ID)
        }
        
      } catch (err) {
        console.error('Erro ao carregar remessa:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao carregar remessa'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async onContaChange() {
      if (this.remessa.CONTA_ID) {
        await this.carregarBoletos()
      } else {
        this.boletos = []
      }
    },
    
    async carregarBoletos() {
      if (!this.remessa.CONTA_ID) return
      
      try {
        this.loadingBoletos = true
        
        let endpoint
        if (this.isNovo) {
          // Modo inclusão: busca boletos disponíveis
          endpoint = `/api/protected/boleto/remessa/getBoletosAbertos/${this.remessa.CONTA_ID}`
        } else {
          // Modo consulta: busca boletos que foram marcados nesta remessa
          endpoint = `/api/protected/boleto/remessa/getBoletosMarcados/${this.remessa.ID}`
        }
        
        const { data } = await this.$http.get(endpoint)
        this.boletos = (Array.isArray(data) ? data : []).map(b => ({
          ...b,
          SELECIONADO: !this.isNovo // Em modo consulta, todos aparecem como "marcados"
        }))
        
      } catch (err) {
        console.error('Erro ao carregar boletos:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao carregar boletos'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
        this.boletos = []
      } finally {
        this.loadingBoletos = false
      }
    },
    
    marcarTodos() {
      this.boletos.forEach(b => b.SELECIONADO = true)
    },
    
    desmarcarTodos() {
      this.boletos.forEach(b => b.SELECIONADO = false)
    },
    
    onBoletoSelectionChange() {
      // Forçar reatividade
      this.$forceUpdate()
    },
    
    rowClassBoleto(item) {
      return item && item.SELECIONADO ? 'cec-row-selected' : ''
    },
    
    async gerarRemessa() {
      if (!this.validar()) return
      
      if (this.quantidadeMarcados === 0) {
        this.$bvToast.toast('Selecione ao menos um boleto para gerar a remessa', { variant: 'warning', solid: true })
        return
      }
      
      const confirmado = await this.$bvModal.msgBoxConfirm(
        `Confirma a geração da remessa com ${this.quantidadeMarcados} boletos?`,
        {
          title: 'Confirmar Geração',
          okVariant: 'success',
          okTitle: 'Sim, Gerar',
          cancelTitle: 'Não'
        }
      )
      
      if (!confirmado) return
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const boletosMarcados = this.boletos.filter(b => b.SELECIONADO)
        
        const payload = {
          registro: {...this.remessa},
          usuario: window.localStorage.getItem('login'),
          empresaId: this.remessa.EMPRESA_ID,
          contaId: this.remessa.CONTA_ID,
          boletos: boletosMarcados,
          
        }
        
        const { data } = await this.$http.post('/api/protected/integrador/gerarRemessaBoleto', payload)
        
        if (data && data.sucesso && data.arquivoRemessaBase64 && data.nomeArquivo) {
          // Converter base64 para blob
          const byteCharacters = atob(data.arquivoRemessaBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'text/plain' })
          
          // Criar link de download e simular clique
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', data.nomeArquivo)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          
          // Desligar o aguardando imediatamente
          this.$store.commit('controle/setAguardando', false)
          
          this.$bvToast.toast('Remessa gerada com sucesso!', { variant: 'success', solid: true })
          
          // Setar o ID da remessa criada para manter seleção na listagem
          if (data.remessaId) {
            this.$store.commit('boletoRemessa/SET_REGISTRO_SELECIONADO_ID', data.remessaId)
          }
          
          // Sinalizar para recarregar a lista ao voltar
          this.$store.commit('boletoRemessa/SET_DEVE_RECARREGAR_LISTA', true)
          
          // Usar setTimeout para navegar após processar tudo
          setTimeout(() => {
            this.$router.push('/faturamento/remessa/index')
          }, 100)
        } else {
          throw new Error(data?.erro || 'Erro ao gerar arquivo de remessa')
        }
        
      } catch (err) {
        console.error('Erro ao gerar remessa:', err)
        const mensagem = err?.response?.data?.erro || err?.message || 'Erro ao gerar remessa'
        this.$bvToast.toast(mensagem, { variant: 'danger', solid: true })
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    validar() {
      if (!this.remessa.EMPRESA_ID) {
        this.$bvToast.toast('Selecione a empresa', { variant: 'warning', solid: true })
        return false
      }
      
      if (!this.remessa.CONTA_ID) {
        this.$bvToast.toast('Selecione a conta bancária', { variant: 'warning', solid: true })
        return false
      }
      
      if (!this.remessa.DATA_CADASTRO) {
        this.$bvToast.toast('Informe a data de cadastro', { variant: 'warning', solid: true })
        return false
      }
      
      return true
    },
    
    voltar() {
      this.$router.push('/faturamento/remessa/index')
    },
    
    formatDate(val) {
      return val ? moment(String(val)).format('DD/MM/YYYY') : ''
    },
    
    formatCurrency(val) {
      return val != null ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
    }
  }
}
</script>

<style lang="scss">
.remessa-cadastro {
  .cec-header__icon {
    background: rgba(255, 255, 255, 0.15) !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    
    &::before {
      display: block !important;
    }
  }
}

.modal-label-premium {
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.4rem;
  display: block;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white !important;
  border-radius: 20px;
  padding: 6px 16px;
  font-weight: 600;
  font-size: 0.8rem;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    text-decoration: none;
  }
  
  &.btn-glass-success {
    background: rgba(40, 167, 69, 0.2);
    border-color: rgba(40, 167, 69, 0.3);
    &:hover { background: rgba(40, 167, 69, 0.3); }
  }
}

.rounded-pill-20 {
  border-radius: 20px !important;
}

.modern-premium-table {
  border-collapse: separate;
  border-spacing: 0;
  
  thead th {
    background-color: #f8fafc !important;
    color: #64748b !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-size: 0.75rem !important;
    letter-spacing: 0.025em !important;
    padding: 12px 16px !important;
    border-top: none !important;
    border-bottom: 2px solid #e2e8f0 !important;
  }
  
  tbody td {
    padding: 8px 16px !important;
    vertical-align: middle !important;
    border-bottom: 1px solid #edf2f7 !important;
    font-size: 0.875rem !important;
  }
  
  tbody tr {
    transition: all 0.2s;
    
    &:hover {
      background-color: #f1f5f9 !important;
    }
    
    &.cec-row-selected {
      background-color: #e0f2fe !important;
      td {
        color: #0369a1 !important;
        font-weight: 500;
      }
    }
  }
}

.bg-soft-success { background-color: rgba(34, 197, 94, 0.1); }
.bg-soft-info { background-color: rgba(14, 165, 233, 0.1); }
.bg-soft-primary { background-color: rgba(59, 130, 246, 0.1); }

.shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }

.custom-checkbox-premium {
  .custom-control-label::before {
    border-radius: 4px;
    border: 2px solid #cbd5e1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/boleto/BoletoRemessaCadastro.vue